import React, { useState } from 'react';
import { SparkIcon, Text } from '@spark';
import './versionsDiff.css';

/** Collapsible section row inside the Versions Diff modal (chevron + bold title). */
const DiffSection = ({ title, defaultOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="vdm-section">
      <button
        type="button"
        className="vdm-section-header"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <SparkIcon slug={open ? 'chevron-down' : 'chevron-right'} size="small" />
        <Text variant="base-semibold" color="primary">{title}</Text>
      </button>
      {open ? <div className="vdm-section-body">{children}</div> : null}
    </div>
  );
};

export default DiffSection;
